import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { JhiConfigService } from '../../shared/core-utils';

@Component({
    selector: 'jhi-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {
    errorMessage: string;
    error403: boolean;
    private subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private translateService: TranslateService,
        private configService: JhiConfigService
    ) {
        const config = this.configService.getConfig();
        const currentLang = config.defaultI18nLang;
        translateService.currentLang = '';
        translateService.use (currentLang);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        this.subscription = this.route.data.subscribe((routeData) => {
            if (routeData.error403) {
                this.error403 = routeData.error403;
            }
            if (routeData.errorMessage) {
                this.errorMessage = routeData.errorMessage;
            }
        });
    }
}
